import { Subject } from 'rxjs';
import { appUtils }  from 'libs-frontend-micro-base';
declare let gigya: any;
import { environment } from 'environments/environment';
import { Injectable } from "@angular/core";

@Injectable()
export class GigyaSessionService {
    // Variable to store user data. 
    // This is fetched only once from GIGYA and then stored in this variable for further requests
    userData: any = false;

    // This is used by various angular components to listen to GIGYA load event
    ongigyaLoad: Subject<any> = new Subject();

    constructor(){}
        
    // return current Gigya user data, if Gigya session is valid 
    getUserData(): Promise<any>{    
        return new Promise((resolve, reject)=>{
            let self = this;

            if(this.userData){
                resolve(this.userData);
                return;
            }

            if(!environment.isDesktopApp){
                gigya.accounts.getAccountInfo({
                    include : 'identities-active,loginIDs,profile,data',
                    callback: function(res){
    
                        if(res.errorCode === 0 && res.UID){
                            self.userData = res;
                            self.userData.c1UserRole = appUtils.getC1UserRole(res);
                        }
                        else{
                            self.userData = false;  
                        }
                        resolve(self.userData);
                    }
                });
            }
        }); 
        
    }

    // cleans userData
    clearUserdata(){
        this.userData = false;
    }

    gigyaLogout() : Promise<any> {
        return new Promise((resolve, reject)=>{
            let self = this;
            if(!environment.isDesktopApp){
                gigya.accounts.logout({
                    forceProvidersLogout: false,
                    callback: () => {
                        self.clearUserdata();
                        resolve(null);
                    }
                });
            }
        });
    }

    setAccountInfo(data){
        return new Promise( (resolve, reject) => {
            let params = {callback: (res)=>{
                if(res.errorCode == 0) resolve(res);
                else reject(res);
            }}
            if(!environment.isDesktopApp){
                gigya.accounts.setAccountInfo({...params,...data});
            }
        })
        
    }

    //Function to return "ongigyaLoad"
    getGigyaLoadListener(){
        return this.ongigyaLoad;
    } 

    // This function listens to "gigyaloaded" event on window object 
    // and initializes a observable "ongigyaLoad" which is used by angular components to paint user data
    createGigyaLoadObservable() {
        window.addEventListener('gigyaLoaded', async () => {
            await this.getUserData();
            this.ongigyaLoad.next(true);
        });
    }
}